import PropTypes from 'prop-types';
// @flow

import React from 'react';
import _ from 'lodash';
import I18n from 'PMT/i18n/I18n';
import Switch from 'react-bootstrap-switch';

import { Restaurant } from 'PMT/entities';
import { OrderSettings } from 'PMT/entities/order';

//
// components
//
import AbstractOrderSettingsForm from '../components/AbstractOrderSettingsForm';
import NumberOfDaysToProposeView from './components/NumberOfDaysToProposeView';
import PaymentModesView from './components/PaymentModesView';
import PaymentMethodsAllowed from './components/PaymentMethodsAllowed';

import FormGroupView from 'PMT/components/form/FormGroupView';
import PriceInput from 'PMT/components/form/PriceInput';
import TipTooltip from 'PMT/components/TipTooltip';

import { Form } from 'react-bootstrap';

export default class TakeAwaySettingsPage extends AbstractOrderSettingsForm {

  static propTypes = {
    restaurant: PropTypes.instanceOf(Restaurant),

    orderSettings: PropTypes.instanceOf(OrderSettings),

    onSubmit: PropTypes.func.isRequired,
  };

  state = this.getDefaultState(this.props.orderSettings);

  //
  //
  //

  onNumberOfDaysToProposeChange = (newValue: number) => {
    const orderSettings: OrderSettings = this.orderSettings;
    orderSettings.takeAwaySettings.setMaxTimeAheadWithDays(newValue);
    this.onChangeOrderSettings(orderSettings);
  };

  onChangeOnSitePaymentModesSettings = (newValue: PaymentModes) => {
    const orderSettings: OrderSettings = this.orderSettings;
    orderSettings.takeAwaySettings.onSite = newValue;
    this.onChangeOrderSettings(orderSettings);
  };

  onMinimumPriceChange = (minimumPrice: number) => {
    const orderSettings: OrderSettings = this.orderSettings;
    orderSettings.takeAwaySettings.minimumPrice = minimumPrice;
    this.onChangeOrderSettings(orderSettings);
  };

  onItemsSequencedEnabledChange = () => {
    const orderSettings: OrderSettings = this.orderSettings;
    orderSettings.takeAwaySettings.itemsSequenced = !orderSettings.takeAwaySettings.itemsSequenced;
    this.onChangeOrderSettings(orderSettings);
  };

  //
  // Renderers
  //

  renderMinimumPrice() {
    return (
      <FormGroupView>
        <FormGroupView.Label>
          {I18n.tr('order.settings.take_away.minimum_price')}
        </FormGroupView.Label>
        <FormGroupView.Content>
          <PriceInput
            value={this.orderSettings.takeAwaySettings.minimumPrice}
            onChange={this.onMinimumPriceChange}
            currencyCode={this.props.restaurant.currency}
            readOnly={!this.canEditSettings()}
          />
        </FormGroupView.Content>
      </FormGroupView>
    );
  }

  renderNumberOfDaysToPropose() {
    return (
      <NumberOfDaysToProposeView
        numberOfDays={this.orderSettings.takeAwaySettings.getMaxTimeAheadAsDays()}
        onChange={this.onNumberOfDaysToProposeChange}
        readOnly={!this.canEditSettings()}
      />
    );
  }

  renderPaymentMethods() {
    return (
      <PaymentMethodsAllowed
        restaurant={this.props.restaurant}
        modeSettings={this.orderSettings.takeAwaySettings}
        onClick={(value) => this.onPaymentMethodsChange(value, this.orderSettings.takeAwaySettings)}
        disabled={!this.canEditSettings()}
      />
    );
  }

  renderPaymentsModes() {
    return (
      <PaymentModesView
        onSitePaymentModes={this.orderSettings.takeAwaySettings.onSite}
        onChange={this.onChangeOnSitePaymentModesSettings}
        readOnly={!this.canEditSettings()}
      />
    );
  }

  renderItemsSequenced() {
    return (
      <FormGroupView>
        <FormGroupView.Label>
          {I18n.tr('order.settings.itemsSequenced')}
          <TipTooltip
            text={I18n.tr('order.settings.itemsSequenced.tooltip')}
          />
        </FormGroupView.Label>
        <FormGroupView.Content>
          <Switch
            bsSize="mini"
            value={this.orderSettings.takeAwaySettings.itemsSequenced}
            onChange={this.onItemsSequencedEnabledChange}
            disabled={!this.canEditSettings()}
          />
        </FormGroupView.Content>
      </FormGroupView>
    )
  }

  renderBody() {
    return (
      <Form horizontal>
        {this.renderNumberOfDaysToPropose()}
        {this.renderPaymentMethods()}
        {this.renderMinimumPrice()}
        {this.renderItemsSequenced()}

        {/* <hr /> */}

        {/* {this.renderPaymentsModes()} */}

        <hr />

        {this.renderFixedButtons()}
      </Form>
    );
  }

  render() {
    try {
    return (
      <div>
        {this.renderBody()}
      </div>
    );
  } catch (e) { console.error(e); }
  }

}
